/**
 * Constructs the LiveKit server URL based on project URL and optional region.
 * Handles region insertion for LiveKit Cloud URLs.
 */
export const getLiveKitURL = (projectUrl: string, region: string | null): string => {
  const url = new URL(projectUrl);
  if (region && url.hostname.includes("livekit.cloud")) {
    const splitHost = url.hostname.split(".");
    const projectId = splitHost[0];
    const isStaging = splitHost.includes("staging");
    const hostParts = isStaging ? splitHost.slice(1) : ["production", ...splitHost.slice(1)];
    url.hostname = [projectId, region, ...hostParts].join(".");
  }
  return url.toString();
};
